import { render } from "./SearchInput.vue?vue&type=template&id=2bf4829e&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=2bf4829e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bf4829e"

export default script